import { useEffect } from 'react';
import { PhoneMissed, X } from 'lucide-react';
import { useVoiceAgentStore } from '@stores/voiceAgentStore';

const SHOW_FOR_MS = 10_000;

/**
 * A short line about a call that went away while it was ringing for this
 * agent — the caller hung up, another tab answered, or it was passed on —
 * so a ring that simply vanished is never a mystery. Shown on every page.
 */
export function CallNotice() {
  const notice = useVoiceAgentStore((s) => s.notice);
  const setNotice = useVoiceAgentStore((s) => s.setNotice);

  useEffect(() => {
    if (!notice) return;
    const t = setTimeout(() => setNotice(null), SHOW_FOR_MS);
    return () => clearTimeout(t);
  }, [notice, setNotice]);

  if (!notice) return null;

  return (
    <div
      role="status"
      className="fixed bottom-5 right-5 z-50 flex max-w-sm items-start gap-3 border border-[var(--co-line)] bg-[var(--co-raised)] px-4 py-3"
      style={{ borderRadius: 10, boxShadow: 'var(--co-shadow-card)' }}
    >
      <PhoneMissed className="mt-[2px] h-4 w-4 flex-none text-[var(--co-terracotta)]" />
      <p className="flex-1 text-[12.5px] leading-[1.45] text-[var(--co-ink)]">{notice}</p>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={() => setNotice(null)}
        className="text-[var(--co-ink-3)] hover:text-[var(--co-ink)]"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
